<template>
    <td-dialog
        :title="title"
        :before-close="orgTreeDialogClose"
        :visible.sync="dialogOrgGroupTreeVisible"
        width="25%"
        append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-row>
            <el-col :span="24">
                <td-tree
                    :height="300"
                    :lazyloading="true"
                    :draggable="false"
                    :isDbClick="false"
                    :isClick="false"
                    :imgloading="true"
                    :typeContent="typeContent"
                    :defaultProps="defaultDeptProps"
                    ref="Tdtree"
                    :checkNodes="checkedOrgIdList"
                    :showBox="true"
                    :sCodes="sCodes"
                    :checkStrictly="true"
                    :calInternal="true"
                    :isDistributed="true"
                    :interfaceName="orgTreeUrl"
                    :params="pramars"
                    :isPaging="true"
                    node-key="id"
                >
                </td-tree>
            </el-col>
        </el-row>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formOrgTreeInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="orgTreeDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogOrgGroupTreeVisible', 'checkedOrgIdList', 'orgTreeUrl'],
    created() {},
    mounted() {
        this.$nextTick(function() {
            this.$refs.Tdtree.setCheckedNodes(this.checkedOrgIdList);
        });
    },
    // 定义变量
    data() {
        return {
            // OrgTree表单信息
            formOrgTreeInfo: {
                sId: '',
                sName: '',
                iOrder: '',
                sSysFlg: ''
            },
            pramars: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            typeContent: [{ sIcon: 'FIRST_CLASS' }, { sIcon: 'SECOND_CLASS' }],
            orgTypeIds: [2],
            formLabelWidth: '30%',
            defaultDeptProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            }
        };
    },

    // 定义并实现方法体
    methods: {
        checkChange(item, node, self) {
            if (node === true) {
                // 点击未选中复选框
                this.editCheckId = item.sId;
                this.$refs.tree.setCheckedKeys([item.sId]);
            } else {
                if (this.editCheckId === item.sId) {
                    // 点击已选中复选框，保证至少一个选中
                    this.$refs.tree.setCheckedKeys([item.sId]);
                }
            }
        },
        // 提交数据
        submitForm() {
            this.$emit('getCheckedOrgList', this.$refs.Tdtree.getCheckedNodes());
            this.$emit('orgTreeDialogClose');
            this.$emit('submit');
        },
        // 关闭窗口之前需要调用的方法
        orgTreeDialogClose() {
            this.$emit('orgTreeDialogClose');
            // this.$refs['formOrgTreeInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
